import { useEffect, useState } from 'react';

export function useGridConfig(containerWidth: number, count: number) {
  const isTwoColumns = count > 7;
  const minWidth = isTwoColumns ? 70 : 110;
  const maxWidth = 150;
  const idealWidth = 130;
  const heightRatio = 160 / 130; // Keeping the same aspect ratio

  const [config, setConfig] = useState({
    columns: 1,
    thumbnailWidth: idealWidth,
    thumbnailHeight: Math.round(idealWidth * heightRatio),
    gridWidth: containerWidth,
  });

  useEffect(() => {
    function calculateGridConfig() {
      let columns = Math.floor(containerWidth / minWidth);
      let thumbnailWidth = Math.max(minWidth, Math.min(maxWidth, containerWidth / columns));

      if (isTwoColumns) {
        thumbnailWidth -= 10;
      }

      setConfig({
        columns,
        thumbnailWidth,
        thumbnailHeight: Math.round(thumbnailWidth * heightRatio),
        gridWidth: thumbnailWidth * columns + 20,
      });
    }

    calculateGridConfig();
  }, [containerWidth, isTwoColumns]);

  return config;
}
